import React from 'react';
import { FormattedMessage } from 'react-intl';
import { KeyValue } from '@folio/stripes/components';
import { mapLinksFromDataFields } from '../../utils/mapLinks';
/**
 * CZNA-820: "open on a map" for a record with coordinates in `034` — one Mapy.cz and one
 * Google Maps link per location, composed at render time (see `utils/mapLinks`). Renders
 * nothing at all for a record without readable coordinates, not even the label.
 */
var MapLinks = function (_a) {
    var dataFields = _a.dataFields;
    var links = mapLinksFromDataFields(dataFields);
    if (links.length === 0)
        return null;
    return (React.createElement(KeyValue, { label: React.createElement(FormattedMessage, { id: "ui-czna-authorities.authorities.detail.mapLinks" }), value: (React.createElement("div", { "data-testid": "record-map-links" }, links.map(function (link) { return (React.createElement("div", { key: link.label },
            React.createElement("span", { "data-testid": "record-map-location" }, link.label),
            ' — ',
            React.createElement("a", { href: link.mapyCz, target: "_blank", rel: "noopener noreferrer", "data-testid": "record-map-link-mapy-cz" },
                React.createElement(FormattedMessage, { id: "ui-czna-authorities.authorities.detail.mapLinks.mapyCz" })),
            ' · ',
            React.createElement("a", { href: link.googleMaps, target: "_blank", rel: "noopener noreferrer", "data-testid": "record-map-link-google" },
                React.createElement(FormattedMessage, { id: "ui-czna-authorities.authorities.detail.mapLinks.googleMaps" })))); }))) }));
};
export default MapLinks;
